<template>
  <div
    class="is-flex is-flex-justify-content-between"
  >
    <span class="is-flex-grow-1">
      {{ auditorName ? auditorName : '' }}
    </span>
    <span v-if="isAuditorEditable" class="ml-2">
      <b-icon icon="edit" custom-size="sm" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'AuditListAuditorItem',
  props: {
    isAuditorEditable: {
      required: true,
      type: Boolean
    },
    auditorName: {
      required: true,
      type: String
    }
  }
}
</script>
